import * as React from "react";

function SvgIcons8NextPage(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path d="M16 3C8.832 3 3 8.832 3 16s5.832 13 13 13 13-5.832 13-13S23.168 3 16 3zm0 2c6.086 0 11 4.914 11 11s-4.914 11-11 11S5 22.086 5 16 9.914 5 16 5zm-1.781 4.281L12.78 10.72 18.062 16l-5.28 5.281 1.437 1.438 6-6 .687-.719-.687-.719z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8NextPage);
